export default __webpack_public_path__ + "static/media/darkbackground.8a655ab6.png";